module.exports = __webpack_public_path__ + "static/media/binance.db8712ff.svg";